import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQ } from "../data/salonData";

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 sm:py-28 px-5 sm:px-8 lg:px-12 max-w-4xl mx-auto"
    >
      <div className="text-center max-w-2xl mx-auto reveal">
        <span className="label-eyebrow">FAQ</span>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-luxuryBlack">
          Good to <span className="hero-script">know</span>.
        </h2>
      </div>

      <div className="mt-12 reveal">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQ.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="glass-card rounded-2xl border-0 px-5"
            >
              <AccordionTrigger className="text-left font-display text-lg py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-luxuryBlack/70 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
